const SCOPE = 'anonymizer'

export const anonymizerKeys = {
  databasePendingApprovalCounts: () => [{ scope: SCOPE, entity: 'databasePendingApprovalCounts' }] as const,
  containers: (dbName: string) => [{ scope: SCOPE, entity: 'containers', dbName }] as const,
  allContainers: () => [{ scope: SCOPE, entity: 'containers' }] as const,
  containerStatuses: () => [{ scope: SCOPE, entity: 'containerStatuses' }] as const,
  fieldConfigs: (dbName: string, containerName: string) =>
    [{ scope: SCOPE, entity: 'fieldConfigs', dbName, containerName }] as const,
  allFieldConfigs: () => [{ scope: SCOPE, entity: 'fieldConfigs' }] as const,
  anonymizationDashboard: (dbName: string) => [{ scope: SCOPE, entity: 'anonymizationDashboard', dbName }] as const,
  allAnonymizationDashboard: () => [{ scope: SCOPE, entity: 'anonymizationDashboard' }] as const,
}
